// src/views/Procesos/EjecutarProceso.jsx
import React, { useEffect, useState } from "react";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson, notify} from "../../../utils/http";
import BtnGuardar from "../../../components/buttons/BtnGuardar";

export default function EjecutarProceso({
  procesoId,
  titulo = "Ejecutar Proceso",
  redirectView,
  onRedirect,
  showSuccess = false,   // ⬅️ NUEVO
}) {

  const [proceso, setProceso] = useState(null);
  const [ejecutando, setEjecutando] = useState(false);
  const [error, setError] = useState(null);

  // ============================
  // CARGA DEL PROCESO
  // ============================
  useEffect(() => {
    const loadProceso = async () => {
      try {
        const data = await appFetchJson(
          apiRoutes.procesos.detail(procesoId)
        );
        setProceso(data);
      } catch (e) {
        console.error(e);
        setError("No se pudo cargar el proceso.");
      }
    };

    loadProceso();
  }, [procesoId]);

  // ============================
  // EJECUTAR
  // ============================
  const ejecutar = async () => {
    setEjecutando(true);
    setError(null);

    try {
      const res = await appFetchJson(
        apiRoutes.procesos.ejecutar(procesoId),
        { method: "POST" },
        {
          showSuccess: false, // ⬅️ controlamos nosotros
        }
      );

      if (res?.status !== "OK") {
        throw new Error(res?.message || "Error al ejecutar el proceso");
      }

      // 🔁 REDIRECCIÓN (prioridad)
      if (redirectView && typeof onRedirect === "function") {
        onRedirect(redirectView);
        return;
      }

      // ✅ OK visual
      if (showSuccess) {
        notify({
          type: "success",
          title: "Proceso ejecutado",
          message: "La operación se realizó correctamente.",
        });
      }

    } catch (e) {
      console.error(e);
      setError(e.message || "Error inesperado al ejecutar el proceso");
    } finally {
      setEjecutando(false);
    }
  };
  // ============================
  // RENDER
  // ============================
  return (
    <div className="page">
      <h1 className="page-title">{titulo}</h1>

      <div className="card max-w-xl mt-6">
        {!proceso ? (
          <p>Cargando proceso…</p>
        ) : (
          <>
            <div className="mb-4">
              <span className="form-label">Proceso:</span>{" "}
              <span className="font-medium">{proceso.codigo}</span>
            </div>

            {error && (
              <div className="alert alert-error mt-4">
                {error}
              </div>
            )}

            <div className="mt-6">
              <BtnGuardar
                label="Ejecutar"
                saving={ejecutando}
                onClick={ejecutar}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
}
